import React from 'react';
import { Col, Input, Row } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Select } from 'components/select';
import { SelectOption } from 'components/select/Select';
import { CLASSIFICATION_DATA } from './SurgeryFilterData';
import { isLocaleEnglish } from 'utils/languageUtils';

const FilterRow = styled(Row)`
  margin-bottom: 1rem;
`;

const FlexCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

const { Search } = Input;

interface FilterSectionProps {
  handleSubmitSearch: (value: string) => void;
  surgerySpecialties: SelectOption[];
  specialty?: string;
  classification?: string;
  handleSpecialtyChange: React.Dispatch<React.SetStateAction<string>>;
  handleClassificationChange: React.Dispatch<React.SetStateAction<string>>;
}

const FilterSection = ({
  handleSubmitSearch,
  surgerySpecialties,
  specialty,
  classification,
  handleSpecialtyChange,
  handleClassificationChange,
}: FilterSectionProps): JSX.Element => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);

  const getClassificationOptionData = () => {
    return CLASSIFICATION_DATA.map(({ name, name_zh, dbValue }) => ({
      id: dbValue,
      label: isEnglish ? name : name_zh,
    }));
  };

  return (
    <FilterRow>
      <Col span={7}>
        <Search placeholder={t('benefits.surgery.searchDesc')} onSearch={handleSubmitSearch} />
      </Col>
      <FlexCol span={6} offset={5}>
        <Select
          value={specialty}
          options={surgerySpecialties}
          onChange={handleSpecialtyChange}
          placeholder={t('benefits.surgery.filterSpecialty')}
          style={{ width: 250 }}
        />
      </FlexCol>
      <FlexCol span={6}>
        <Select
          value={classification}
          options={getClassificationOptionData()}
          onChange={handleClassificationChange}
          placeholder={t('benefits.surgery.filterClassification')}
          style={{ width: 250 }}
        />
      </FlexCol>
    </FilterRow>
  );
};

export default FilterSection;
